/* eslint-disable default-case */
import React, { Component } from 'react';
import { Button, Modal, ModalFooter, ModalHeader, ModalBody, Label, Input, Row, Col, Card, CardBody } from 'reactstrap';
import { ColumnDirective, ColumnsDirective, CommandColumn, GridComponent, Sort, Search, ExcelExport, Edit, Toolbar, ToolbarItems, Filter, Page } from '@syncfusion/ej2-react-grids';
import { DatePickerComponent, TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { ToastUtility } from '@syncfusion/ej2-react-notifications';
import { TextBoxComponent, NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { HtmlEditor, Image, Inject, Count, Link, Toolbar as rteToolbar, QuickToolbar, RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';
import { confirm } from "react-confirm-box";
import { IsAuthenticated, getAuthToken } from '../helpers/authentication';
import { fieldRequired } from '../helpers/validation';
import { GetProvinceName, GetUserTypeName, setEditId } from '../helpers/Lookup';
import ThrobbleHelper from '../helpers/ThrobbleHelper';
import { showToast } from '../helpers/ToastHelper';

export class UserData extends Component {

  static grid = null;

  constructor(props) {
    super(props);
    const commandTemplate = [
      { type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
      { type: 'Delete', buttonOption: { cssClass: 'e-flat', iconCss: 'e-delete e-icons' } }
    ];

    this.state = {
      editData: [], FilterID: 0, loading: true, editModal: false, gridCommands: commandTemplate, gridToolbar: ['Search'],
      showUserImport: false, showUserImportResult: false, FileData: "", ImportResult: null
    };
    this.toggle = this.toggle.bind(this);
    this.toggleUserImport = this.toggleUserImport.bind(this);
    this.toggleUserImportResult = this.toggleUserImportResult.bind(this);
    this.StartImport = this.StartImport.bind(this);
    this.handleImportFileChange = this.handleImportFileChange.bind(this);
    this.RenderActionColumn = this.RenderActionColumn.bind(this)
  }

  toggleUserImport(evt) {
    evt.stopPropagation();
    this.setState({ showUserImport: !this.state.showUserImport }, () => console.log(this.state));
  }

  toggleUserImportResult(evt) {
    evt.stopPropagation();
    this.setState({ showImportResultResult: !this.state.showUserImportResult });
  }


  toggle() {
    this.setState({
      editModal: !this.state.editModal
    });
  }

  componentDidMount() {
    IsAuthenticated().then((res) => {
      if (res) {
        document.title = "Est Africa :: User Administration";
        ThrobbleHelper.toggleThrobble(true, "Getting Users");
        this.loadData();
      }
    }).catch(() => window.location.href = "/login");
  }

  editItem = (id) => {
    console.log(id);
    setEditId(id);
    window.location.href = "/user-profile"
  };

  deleteItem = async (id) => {
    const confirmStyles = {
      classNames: {
        confirmButton: 'btn btn-sm confirm-button',
        cancelButton: 'btn btn-sm cancel-button',
      }
    }
    const result = await confirm("Are you sure you want to delete this item?", confirmStyles);
    if (result) {
      this.deleteData(id);
    }
  }

  onGridCommand = (type, rowData) => {
    switch (type) {
      case 'Edit':
        this.editItem(rowData.id);
        break;
      case 'Delete':
        this.deleteItem(rowData.id);
        break;
    }
  }

  renderUsers(Users, FilterId) {

    const commands = [
      { type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
      { type: 'Delete', buttonOption: { cssClass: 'e-flat', iconCss: 'e-delete e-icons' } },
    ];

    if (FilterId > 0)
      Users = Users.filter(i => i.userType === FilterId);

    return (
      <GridComponent dataSource={Users} commandClick={this.onGridCommand} allowFiltering={true} allowSorting={true} filterSettings={{ type: "Menu" }}
        allowPaging={true} pageSettings={{ pageSize: 25 }} ref={e => UserData.grid = e}>
        <ColumnsDirective>
          <ColumnDirective field='firstName' headerText="First Name" />
          <ColumnDirective field='lastName' headerText="Last Name" />
          <ColumnDirective headerText="User Type" template={this.RenderUserType} />
          <ColumnDirective field='emailAddress' headerText="Email Address" />
          <ColumnDirective field='supplierName' headerText='Supplier' />
          <ColumnDirective headerText='Actions' template={this.RenderActionColumn} />
        </ColumnsDirective>
        <Inject services={[Sort, Edit, Filter, Page, CommandColumn, Toolbar]} />
      </GridComponent>
    )
  }

  RenderActionColumn(props) {
    return (
      <div className='text-center'>
        {props.lockedOut ? <i title='Locked' className='fas fa-lock text-danger me-2'></i> : <i title='Unlocked' className='fas fa-lock-open text-success me-2'></i>}
        <button onClick={() => this.onGridCommand("Edit", props)} className='e-lib e-btn e-control e-flat e-icon-btn e-edit-delete e-editbutton'><i className='e-btn-icon e-edit e-icons'></i></button>
        <button onClick={() => this.onGridCommand("Delete", props)} className='e-lib e-btn e-control e-flat e-icon-btn e-edit-delete e-deletebutton'><i className='e-btn-icon e-delete e-icons'></i></button>
      </div>
    )
  }

  RenderLockedOutState(props) {
    return (<div className='ms-3'>{props.lockedOut ? <i title='Locked' className='fas fa-lock text-danger'></i> : <i title='Unlocked' className='fas fa-lock-open text-success'></i>}</div>)
  }

  RenderUserType(props) {
    return <>{GetUserTypeName(props.userType)}</>
  }

  RenderProvince(props) {
    return <>{GetProvinceName(props.province)}</>;
  }


  async updateUsers() {
    const response = await fetch("api/userdata/UpdateUsers", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      }
    });

    console.log(response);
  }

  render() {
    const UserTypes = [{ value: 0, text: "- All User Types -" }, { value: 10, text: "Suppliers" }, { value: 100, text: "Administrators" }];
    let contents = this.state.loading ? <p className='text-center'><i className='fas fa-spinner fa-spin me-2'></i>Loading...</p> : this.renderUsers(this.state.editData, this.state.FilterID);
    return (
      <>
        <div className="container">
          <Row className='mb-4'>
            <Col xs={6}>
              <h1>User Data Administration</h1>
            </Col>
            <Col xs={6} className="text-end align-self-center">
              {/* <Button color="primary" size="sm" className='me-2' onClick={this.toggleUserImport}>Import Users</Button> */}
              {/* <Button color="primary" size="sm" className='me-2' onClick={this.updateUsers}>Update Users</Button> */}
              <Button color="primary" size="sm" data-recordid="0" onClick={() => this.editItem(0)}>Add New <i className="fas fa-plus-circle ms-2"></i></Button>
            </Col>
          </Row>
          <Row>
            <Col md={6} className='mb-3'>
              <Card>
                <CardBody>
                  <label>Filter By User Type</label>
                  <DropDownListComponent dataSource={UserTypes} fields={{ text: "text", value: "value" }} value={this.state.FilterID} select={e => this.setState({ FilterID: e.itemData.value })} />
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>
              {contents}
            </Col>
          </Row>
        </div>

        <Modal isOpen={this.state.showUserImport} fade toggle={this.toggleUserImport}>
          <ModalHeader toggle={this.toggleUserImport} close={<button
            className="btn-close"
            onClick={this.toggleUserImport}
          ></button>} >
            Import Visitors
          </ModalHeader>
          <ModalBody>

            <label>Import File <small className='text-muted'>(excel)</small>
              <span id="errFile" className='ErrorText' /></label>
            <Input type='file' accept='.xlsx, .xls' onChange={this.handleImportFileChange} />
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' size='sm' onClick={this.toggleUserImport}>Close</Button>
            <Button color='success' size='sm' onClick={this.StartImport}>Import</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.showUserImportResult} fade toggle={this.toggleUserImportResult}>
          <ModalHeader toggle={this.toggleUserImportResult} close={<button
            className="btn-close"
            onClick={this.toggleUserImportResult}
          ></button>} >
            Visitors Import Results
          </ModalHeader>
          <ModalBody>
            <Card>
              <CardBody>
                {this.state.ImportResult &&
                  <>
                    <i className='fas fa-check-circle me-2 text-success'></i>Successes: {this.state.ImportResult.successes}<br />
                    <i className='fas fa-times-circle me-2 text-danger'></i>Errors: {this.state.ImportResult.errors}<br />
                    <i className='fas fa-check-circle me-2 text-warning'></i>Existing: {this.state.ImportResult.existing}<br />
                  </>
                }
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' size='sm' onClick={this.toggleUserImportResult}>Close</Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }

  async StartImport(evt) {
    evt.stopPropagation();
    let isValid = true;
    isValid &= fieldRequired(this.state.FileData, "errFile", "* Required");

    if (isValid) {
      const bearer = "Bearer " + getAuthToken();
      ThrobbleHelper.toggleThrobble(true, "Importing Users");
      try {
        const response = await fetch("/api/userdata/ImportUsers", {
          method: "POST",
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': bearer,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ FileData: this.state.FileData })
        });

        if (response.ok) {

          const data = await response.json();
          this.loadData();
          this.setState({ ImportResult: data.item1, showUserImportResult: true });
          ThrobbleHelper.toggleThrobble(false);

        } else {
          if (response.status === 401)
            window.location.href = "/login";
          else {
            showToast("error", "Users Import", "There was an error importing users");
            ThrobbleHelper.toggleThrobble(false);
          }
        }
      } catch (e) {
        console.error(e);
        showToast("error", "Users Import", "There was an error importing users");
        ThrobbleHelper.toggleThrobble(false);
      }
    }

  }

  handleImportFileChange(evt) {
    const SelectedFile = evt.target.files[0];
    if (SelectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const FileData = e.target.result;
        this.setState({
          FileData
        });
      }
      reader.readAsDataURL(SelectedFile);
    }
  }

  async loadData() {

    var bearer = 'Bearer ' + getAuthToken();
    try {
      const response = await fetch('api/userdata', {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        this.setState({ editData: data, loading: false });
        ThrobbleHelper.toggleThrobble(false);
      }
      else {
        console.log(response.status + ": " + response.statusText);
        if (response.status === 401)
          window.location.href = "/login";
        ThrobbleHelper.toggleThrobble(false);
      }
    } catch (e) {
      console.error(e);
      ThrobbleHelper.toggleThrobble(false);
    }
  }


  async deleteData(dataId) {
    // this.setState({ loading: true });

    ThrobbleHelper.toggleThrobble(true, "Deleting User");
    var bearer = 'Bearer ' + getAuthToken();
    try {
      const response = await fetch('api/userdata/' + dataId, {
        method: 'DELETE',
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        await response.json();
        this.loadData();
        showToast(
          "success",
          "User Data",
          "The user data was successfully deleted!"
        );
      }
      else {
        console.log(response.status + ": " + response.statusText);
        if (response.status === 401)
          window.location.href = "/login";
        showToast(
          "error",
          "User Data",
          "There was an error deleting the user data"
        );
        ThrobbleHelper.toggleThrobble(false);

      }
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
      showToast(
        "error",
        "User Data",
        "There was an error deleting the user data"
      );
      ThrobbleHelper.toggleThrobble(false);

    }
  }
}

